import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes, FaCaretDown } from "react-icons/fa";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../Firebase";

function Header() {
  const [hdata, setHdata] = useState([]);
  const [nav, setNav] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const hamClick = () => setNav(!nav);
  const dropClick = () => setDropdown(!dropdown);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, "header", "brIl9nwad7ZPXKk66wCO"),
      (doc) => {
        setHdata(doc.data());
      }
    );

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <div
      id="container"
      name="nav"
      className="fixed h-[76px] bg-slate-900 shadow-lg shadow-yellow-600 border-b-4 border-yellow-600"
    >
      <header className="max-w-[1440px] w-full p-4 flex justify-between items-center">
        {/* Logo */}
        <Link to="/">
          <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center gap-3">
            <img
              className="object-fill w-full h-full "
              src={hdata.logo}
              alt="crionsas-logo"
            />
            <strong className="lg:text-2xl font-mono">CrionSAS</strong>
          </div>
        </Link>
        {/* Logo */}

        {/* Mobile Nav */}
        <div onClick={hamClick} className="z-10 lg:hidden">
          {!nav ? <FaBars /> : <FaTimes />}
        </div>
        <div
          className={
            !nav
              ? "hidden"
              : "flex flex-col items-start shadow-2xl absolute top-0 h-screen w-2/4 right-0 bg-slate-900"
          }
        >
          <div className="w-full pl-2">
            <div className="my-5">
              <a
                className="pbtn"
                onClick={hamClick}
                href={hdata.resume}
                target="_blank"
                rel="noreferrer"
              >
                Resume
              </a>
            </div>
            <ul>
              <Link onClick={hamClick} to="/">
                <li className="p-3 hover:bg-sColor border-y-slate-800 border-y">
                  Blogs
                </li>
              </Link>
              <Link onClick={hamClick} to="/about">
                <li className="p-3 hover:bg-sColor border-y-slate-800 border-y">
                  About
                </li>
              </Link>
              <Link onClick={hamClick} to="/contact">
                <li className="p-3 hover:bg-sColor border-y-slate-800 border-y">
                  Contact
                </li>
              </Link>
              <li className="p-3 hover:bg-sColor border-y-slate-800 border-y">
                <details close>
                  <summary>Tools</summary>
                  <Link onClick={hamClick} to="/calculator">
                    <li className="p-2 mt-2 hover:bg-sColor border-y-slate-800 border-y">
                      Calculator
                    </li>
                  </Link>
                </details>
              </li>
            </ul>
          </div>
        </div>
        {/* Mobile Nav */}

        {/* nav items */}
        <div className="hidden lg:flex">
          <ul className="flex gap-x-10 ">
            <Link to="/">
              <li className="hover:text-slate-400">Blogs</li>
            </Link>
            <Link to="/about">
              <li className="hover:text-slate-400">About</li>
            </Link>
            <Link to="/contact">
              <li className="hover:text-slate-400">Contact</li>
            </Link>
            <div className="relative">
              <li
                onClick={dropClick}
                className="hover:text-slate-400 flex items-center cursor-pointer"
              >
                Tools
                <FaCaretDown />
              </li>
              <div
                className={
                  dropdown
                    ? "absolute top-12 p-4 bg-slate-800 rounded-lg"
                    : "hidden"
                }
              >
                <ul className="space-y-4">
                  <Link onClick={dropClick} to="/calculator">
                    <li>Calculator</li>
                  </Link>
                </ul>
              </div>
            </div>
          </ul>
        </div>
        {/* nav items */}

        {/* profile */}
        <div className="hidden lg:flex">
          <a
            className="pbtn"
            href={hdata.resume}
            target="_blank"
            rel="noreferrer"
          >
            Resume
          </a>
        </div>
        {/* profile */}
      </header>
    </div>
  );
}

export default Header;
